import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState } from 'react';
import { Box, Button, Dialog, IconButton, Typography, useMediaQuery, useTheme } from '@mui/material';
import { CloseCircle, Edit } from 'iconsax-react';
import { WidgetHeader } from '../../../../components/common/header/widgetHeader/WidgetHeader';
import { CustomChip } from '../../../../components/common/chip/Chip';
import { PrimaryGrid } from '../../../../components/common/grid/PrimaryGrid';
import { useAppSelector } from '@application/store/useStore';
import { HoursStatus } from '@application/common/enums/hours-status';
import { ClientContractStatus } from '@application/common/enums/client-contract-status';
import { DiscardOpenTimeSheet } from './DiscardOpenTimeSheet';
export const OpenTimSheet = ({ open, handleClose, onEdit, beforeRemove, onRemoved, onRemovalBusy }) => {
    const { timeSheetWithClientInfo } = useAppSelector((state) => state.timeSheet);
    const [removeId, setRemoveId] = useState(null);
    const compact = useMediaQuery(useTheme().breakpoints.down('sm'));
    const columns = [
        {
            field: 'monthName',
            headerName: 'Timesheets',
            flex: 2
        },
        {
            field: 'allClientNames',
            headerName: 'Registration',
            flex: 2
        },
        {
            field: 'status',
            headerName: 'Status',
            flex: 2,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => _jsx(CustomChip, { value: params.value })
        },
        {
            field: 'action',
            headerName: 'Edit',
            flex: 0.5,
            renderCell: (params) => (_jsx(IconButton, { "aria-label": `Edit ${params.row.monthName} ${params.row.allClientNames}`, disabled: params.row.assignmentStatus === ClientContractStatus.Expired, onClick: () => {
                    handleEdit(params);
                }, children: _jsx(Edit, {}) }))
        },
        {
            field: 'remove', headerName: 'Remove', width: 100, sortable: false,
            renderCell: (params) => _jsx(Button, { color: 'error', size: 'small', "aria-label": `Remove ${params.row.monthName} ${params.row.allClientNames}`, disabled: !params.row.timeSheetId || params.row.status !== 'Open', onClick: () => { if (!beforeRemove || beforeRemove())
                    setRemoveId(params.row.timeSheetId); }, children: "Remove" })
        }
    ];
    const rows = timeSheetWithClientInfo?.timeSheetWithClientInfo.map((data, index) => {
        return {
            id: index + 1,
            timeSheetId: data.timeSheetIds?.split(',').map(id => id.trim()).find(Boolean),
            monthName: data.monthName,
            allClientNames: data.assignmentStatus == ClientContractStatus.Expired
                ? `${data.contextName || data.allClientNames} (Expired)`
                : data.contextName || data.allClientNames,
            status: `${HoursStatus[data.timeSheetStatus]}`,
            month: data.month,
            year: data.year,
            assignmentId: data.assignmentId,
            contextId: data.contextId ?? data.assignmentId ?? data.internalCompanyId,
            contextType: data.bookingContextType === 1 ? 'InternalDepartment' : 'ClientAssignment',
            contextName: data.contextName,
            assignmentStatus: data.assignmentStatus
        };
    });
    const handleEdit = (params) => {
        const editData = {
            Month: params.row.month,
            Year: params.row.year,
            AssignmentId: params.row.assignmentId ?? '',
            ContextType: params.row.contextType,
            ContextId: params.row.contextId,
            clientName: params.row.contextName || params.row.allClientNames
        };
        onEdit(editData);
    };
    return (_jsxs(_Fragment, { children: [_jsxs(Dialog, { open: open, onClose: handleClose, "aria-labelledby": 'open-timesheets-title', maxWidth: false, BackdropProps: {
                    sx: {
                        backdropFilter: 'blur(3px)',
                        backgroundColor: 'rgba(74, 74, 74, 0.25)'
                    }
                }, PaperProps: {
                    sx: {
                        width: '760px',
                        maxWidth: 'calc(100vw - 32px)',
                        maxHeight: '90vh',
                        overflow: 'hidden'
                    }
                }, children: [_jsx(Box, { sx: {
                            position: 'sticky',
                            top: 0,
                            zIndex: 2,
                            backgroundColor: 'white'
                        }, children: _jsxs(WidgetHeader, { background: 'white', children: [_jsx(Typography, { id: 'open-timesheets-title', fontSize: '20px', color: 'black', sx: {
                                        whiteSpace: 'normal',
                                        wordBreak: 'break-word'
                                    }, children: "Open timesheets" }), _jsx(IconButton, { "aria-label": 'Close open timesheets', onClick: handleClose, sx: { padding: { xs: '0px', md: '8px' } }, children: _jsx(CloseCircle, { style: { color: 'black' } }) })] }) }), _jsx(Box, { sx: {
                            padding: { xs: '16px', md: '25px' },
                            overflowX: 'auto',
                            overflowY: 'auto',
                            maxHeight: 'calc(90vh - 10px)',
                            minWidth: 0
                        }, children: compact ? _jsxs(Box, { sx: { display: 'grid', gap: 1.5 }, children: [(rows ?? []).map(row => _jsxs(Box, { sx: { border: '1px solid', borderColor: 'divider', borderRadius: 2, p: 2 }, children: [_jsx(Typography, { fontWeight: 600, children: row.monthName }), _jsx(Typography, { variant: 'body2', sx: { mt: 0.5, overflowWrap: 'anywhere' }, children: row.allClientNames }), _jsxs(Box, { sx: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1, flexWrap: 'wrap', mt: 1 }, children: [_jsx(CustomChip, { value: row.status }), _jsxs(Box, { sx: { display: 'flex', gap: 1 }, children: [_jsx(Button, { size: 'small', sx: { minHeight: 44 }, "aria-label": `Edit ${row.monthName} ${row.allClientNames}`, disabled: row.assignmentStatus === ClientContractStatus.Expired, onClick: () => handleEdit({ row }), children: "Edit" }), _jsx(Button, { size: 'small', color: 'error', sx: { minHeight: 44 }, "aria-label": `Remove ${row.monthName} ${row.allClientNames}`, disabled: !row.timeSheetId || row.status !== 'Open', onClick: () => { if (!beforeRemove || beforeRemove())
                                                                setRemoveId(row.timeSheetId ?? null); }, children: "Remove" })] })] })] }, row.id)), !rows?.length && _jsx(Typography, { variant: 'body2', children: "No open timesheets." })] }) : _jsx(Box, { sx: { minWidth: '310px' }, children: _jsx(PrimaryGrid, { columns: columns, rows: rows ?? [] }) }) })] }), _jsx(DiscardOpenTimeSheet, { timeSheetId: open ? removeId : null, onClose: () => setRemoveId(null), onRemoved: onRemoved, onBusyChange: onRemovalBusy })] }));
};
